import React, { ReactNode } from 'react';

export interface FiltersProps {
  traits: ReactNode;
}

export const Filters = ({ traits }: FiltersProps) => {
  return <div className="px-4 pb-4 space-y-1">{traits}</div>;
};

export default Filters;
